export const promoBannersFileFormatsMultiSelectTranslationKeys = {
  promoAllFormatsPlaceholder: 'promo.all-formats-placeholder',
  promoFormatLabel: 'promo.format-label',
}
